import React, { useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import { BookOpenIcon, CalendarIcon, MapPinIcon, UsersIcon, AwardIcon, BuildingIcon, MedalIcon, LandmarkIcon, BookIcon, GraduationCapIcon, UserIcon, BriefcaseIcon, HeartIcon, EyeIcon, TargetIcon, PlayIcon } from 'lucide-react';
import Button from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const About = () => {
  const [activeTab, setActiveTab] = useState('history');
  return <div className="min-h-screen bg-white" data-id="element-641">
      <PageHeader title="About Isonyin Grammar School" description="Learn about our rich history, vision, mission, and the values that guide us." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/de3EQh38fKgVchW9xJS4du/WhatsApp_Image_2025-10-24_at_10.01.26.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'About',
      path: '/about'
    }]} data-id="element-642" />
      <div className="container mx-auto px-4 py-12" data-id="element-643">
        {/* Tab Navigation */}
        <div className="flex flex-wrap justify-center gap-2 mb-8 border-b border-gray-200" data-id="element-644">
          {[{
          id: 'history',
          label: 'History & Founding'
        }, {
          id: 'vision',
          label: 'Vision & Mission'
        }, {
          id: 'anthem',
          label: 'School Anthem'
        }, {
          id: 'badge',
          label: 'Badge & Motto'
        }, {
          id: 'leadership',
          label: 'Leadership'
        }].map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-6 py-3 font-medium transition-colors border-b-2 ${activeTab === tab.id ? 'text-blue-900 border-yellow-500' : 'text-gray-600 border-transparent hover:text-blue-900 hover:border-gray-300'}`} data-id="element-645">
              {tab.label}
            </button>)}
        </div>
        {/* History Section */}
        {activeTab === 'history' && <section className="mb-16" id="history" data-id="element-646">
            <div className="text-center mb-10" data-id="element-647">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-648">
                History of Isonyin Grammar School
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-649"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-650">
                Founded in 1956 with the motto "God is our foundation"
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-651">
              <div data-id="element-652">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/c8nkRq8o8BbU7KKu56ZSnF/WhatsApp_Image_2025-08-14_at_15.45.37_%285%29.jpg" alt="Isonyin Grammar School Campus" className="w-full h-auto rounded-lg shadow-lg" data-id="element-653" />
              </div>
              <div className="space-y-4" data-id="element-654">
                <h3 className="text-2xl font-bold text-blue-900" data-id="element-655">
                  The Genesis of a Vision
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-656">
                  The idea for the school originated in 1952 when six visionary
                  gentlemen—Mr. D.B. Ogutuga, Mr. Ephraim Odusote, Mr. Bennett
                  A. O. Sangowanwa, Dr. Festus Aina, Mr. N.A. Okuribido, and
                  Alhaji Disu Akadiri—formed a committee to establish a "Central
                  School" for the Isonyin community. This ambitious idea was
                  enthusiastically adopted by the community, with Chief Adewunmi
                  Onasanya and Mr. D.B. Ogutuga leading a nationwide fundraising
                  effort among Isonyin sons and daughters.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-657">
                  Official approval to establish Isonyin Grammar School as a
                  private institution was granted by the Director of Education,
                  Western Region, Ibadan, on March 7, 1956. The school
                  officially opened with religious activities on March 23, 1956,
                  at Emmanuel Anglican Church, Isonyin. The pioneering staff
                  consisted of Principal Mr. Segun Akinwande and Mr. O.C.E.
                  Madubuke, who began with an inaugural class of 23 boys.
                </p>
              </div>
            </div>
            {/* Key Milestones Timeline */}
            <div className="bg-blue-50 p-8 rounded-lg mb-12" data-id="element-658">
              <h3 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-659">
                Key Milestones and Notable Events
              </h3>
              <div className="space-y-6" data-id="element-660">
                <div className="flex items-start" data-id="element-661">
                  <div className="bg-yellow-500 text-blue-900 font-bold rounded-full w-20 h-20 flex items-center justify-center flex-shrink-0 mr-6 shadow-md" data-id="element-662">
                    <span className="text-lg" data-id="element-663">1956</span>
                  </div>
                  <div className="flex-1" data-id="element-664">
                    <h4 className="font-bold text-blue-900 mb-2" data-id="element-665">
                      School Founded
                    </h4>
                    <p className="text-gray-700" data-id="element-666">
                      Official approval granted on March 7, 1956. School opened
                      on March 23, 1956, with 23 boys and two pioneering staff
                      members.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-667">
                  <div className="bg-yellow-500 text-blue-900 font-bold rounded-full w-20 h-20 flex items-center justify-center flex-shrink-0 mr-6 shadow-md" data-id="element-668">
                    <span className="text-lg" data-id="element-669">1961</span>
                  </div>
                  <div className="flex-1" data-id="element-670">
                    <h4 className="font-bold text-blue-900 mb-2" data-id="element-671">
                      WASC Recognition
                    </h4>
                    <p className="text-gray-700" data-id="element-672">
                      The school was officially recognized for the WASC (West
                      African School Certificate) Examination. 13 students sat
                      for the first WASC exam, with seven passing in various
                      grades.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-673">
                  <div className="bg-yellow-500 text-blue-900 font-bold rounded-full w-20 h-20 flex items-center justify-center flex-shrink-0 mr-6 shadow-md" data-id="element-674">
                    <span className="text-lg" data-id="element-675">1963</span>
                  </div>
                  <div className="flex-1" data-id="element-676">
                    <h4 className="font-bold text-blue-900 mb-2" data-id="element-677">
                      Expansion Approved
                    </h4>
                    <p className="text-gray-700" data-id="element-678">
                      The school received approval to expand to a double stream,
                      marking the beginning of significant growth.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-679">
                  <div className="bg-yellow-500 text-blue-900 font-bold rounded-full w-20 h-20 flex items-center justify-center flex-shrink-0 mr-6 shadow-md" data-id="element-680">
                    <span className="text-lg" data-id="element-681">1966</span>
                  </div>
                  <div className="flex-1" data-id="element-682">
                    <h4 className="font-bold text-blue-900 mb-2" data-id="element-683">
                      Discipline Maintained
                    </h4>
                    <p className="text-gray-700" data-id="element-684">
                      A significant event with the expulsion of 13 students for
                      "rioting," demonstrating the school's early commitment to
                      discipline and order.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-685">
                  <div className="bg-yellow-500 text-blue-900 font-bold rounded-full w-20 h-20 flex items-center justify-center flex-shrink-0 mr-6 shadow-md" data-id="element-686">
                    <span className="text-sm" data-id="element-687">1970-78</span>
                  </div>
                  <div className="flex-1" data-id="element-688">
                    <h4 className="font-bold text-blue-900 mb-2" data-id="element-689">
                      Continued Growth
                    </h4>
                    <p className="text-gray-700" data-id="element-690">
                      The school's growth continued with approvals to run three,
                      four, and then five streams of classes, accommodating more
                      students.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-691">
                  <div className="bg-yellow-500 text-blue-900 font-bold rounded-full w-20 h-20 flex items-center justify-center flex-shrink-0 mr-6 shadow-md" data-id="element-692">
                    <span className="text-lg" data-id="element-693">1980</span>
                  </div>
                  <div className="flex-1" data-id="element-694">
                    <h4 className="font-bold text-blue-900 mb-2" data-id="element-695">
                      Co-Educational Status
                    </h4>
                    <p className="text-gray-700" data-id="element-696">
                      A landmark year as Isonyin Grammar School was approved to
                      become a co-educational institution, admitting both boys
                      and girls for the first time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* The School Today */}
            <div className="bg-white rounded-lg shadow-md p-8" data-id="element-697">
              <h3 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-698">
                The School Today
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-699">
                <div data-id="element-700">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg" alt="Modern Campus" className="w-full h-auto rounded-lg shadow-md" data-id="element-701" />
                </div>
                <div className="space-y-4" data-id="element-702">
                  <p className="text-gray-700 leading-relaxed" data-id="element-703">
                    Today, Isonyin Grammar School occupies a vast land area of
                    over 100 hectares. In line with Nigeria's Universal Basic
                    Education policy, the school has been disarticulated into
                    separate Junior and Senior Secondary Schools.
                  </p>
                  <p className="text-gray-700 leading-relaxed" data-id="element-704">
                    It holds the prestigious distinction of being a flagship
                    school for the Ogun State Government and is the only such
                    recognized school with boarding facilities in the entire
                    Ijebu North-East Local Government Area. Students gain
                    admission to JSS 1 through a state-organized Common Entrance
                    Examination specifically for flagship and model schools.
                  </p>
                  <p className="text-gray-700 leading-relaxed" data-id="element-705">
                    The school's remarkable development and academic
                    achievements are largely a result of the immense support it
                    receives. Contributions from the Old Students Association,
                    our revered Kabiyesi, HRM Oba Abdul-Rasheed Cossy Salami
                    (Ilufemiloye 1) - the Saderiren of Isonyin, the Forum of
                    Isonyin Professors, and other notable individuals have
                    played a crucial role in its growth and success, solidifying
                    its place as a leading secondary school in Nigeria.
                  </p>
                </div>
              </div>
            </div>
          </section>}
        {/* Vision & Mission Section */}
        {activeTab === 'vision' && <section className="mb-16" id="vision" data-id="element-706">
            <div className="text-center mb-10" data-id="element-707">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-708">
                Vision, Mission & Core Values
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-709"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-710">
                Our guiding principles that shape everything we do
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-711">
              <div className="bg-blue-900 text-white p-8 rounded-lg shadow-lg" data-id="element-712">
                <div className="flex items-center mb-6" data-id="element-713">
                  <div className="bg-yellow-500 p-3 rounded-full mr-4" data-id="element-714">
                    <svg className="w-8 h-8 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-715">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-716" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" data-id="element-717" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold" data-id="element-718">Our Vision</h3>
                </div>
                <p className="text-lg leading-relaxed" data-id="element-719">
                  Our Vision is to be the best centre for innovative learning in
                  Ijebu Northeast and one of the leading model schools in Ogun
                  State and by extension, Nigeria, fostering academic excellence
                  and innovation to turn out responsible global citizens.
                </p>
              </div>
              <div className="bg-yellow-500 text-blue-900 p-8 rounded-lg shadow-lg" data-id="element-720">
                <div className="flex items-center mb-6" data-id="element-721">
                  <div className="bg-blue-900 p-3 rounded-full mr-4" data-id="element-722">
                    <svg className="w-8 h-8 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-723">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-724" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold" data-id="element-725">Our Mission</h3>
                </div>
                <p className="text-lg leading-relaxed" data-id="element-726">
                  To provide blended learning experience, engaging curriculum,
                  conducive learning atmosphere that encourage personalised
                  learning, intellectual curiosity, critical thinking, where
                  students of high cognitive and intellectual ability will
                  emerge, providing solution to societal problems.
                </p>
              </div>
            </div>
            {/* School Philosophy */}
            <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white p-10 rounded-lg shadow-xl mb-12" data-id="element-727">
              <div className="text-center mb-8" data-id="element-728">
                <h3 className="text-3xl font-bold mb-2" data-id="element-729">
                  The School Philosophy
                </h3>
                <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-730"></div>
              </div>
              <div className="max-w-3xl mx-auto" data-id="element-731">
                <div className="bg-white/10 backdrop-blur-sm p-8 rounded-lg border-2 border-yellow-500" data-id="element-732">
                  <div className="text-center space-y-4 text-lg" data-id="element-733">
                    <p className="leading-relaxed" data-id="element-734">
                      I shall work hard when it's time to work
                    </p>
                    <p className="leading-relaxed" data-id="element-735">
                      I shall play when it's time to play
                    </p>
                    <p className="leading-relaxed" data-id="element-736">
                      I promise to do other good things
                    </p>
                    <p className="leading-relaxed" data-id="element-737">At the correct time</p>
                    <p className="leading-relaxed" data-id="element-738">
                      That will make Isonyin Grammar School, Isonyin
                    </p>
                    <p className="leading-relaxed font-bold text-yellow-300" data-id="element-739">
                      Better than I met it
                    </p>
                    <p className="leading-relaxed italic mt-6" data-id="element-740">
                      So help me God (Amen)
                    </p>
                  </div>
                  <div className="mt-8 text-center" data-id="element-741">
                    <p className="text-yellow-300 font-semibold" data-id="element-742">
                      Composed by:
                    </p>
                    <p className="text-lg" data-id="element-743">Chief Ayo Olusanya (1971)</p>
                  </div>
                </div>
              </div>
            </div>
            {/* Core Values */}
            <div className="bg-gray-50 p-8 rounded-lg" data-id="element-744">
              <h3 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-745">
                Our Core Values
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-746">
                <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-747">
                  <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-748">
                    <span className="text-2xl" data-id="element-749">📚</span>
                  </div>
                  <h4 className="font-bold text-blue-900 mb-2" data-id="element-750">Excellence</h4>
                  <p className="text-gray-700 text-sm" data-id="element-751">
                    We strive for excellence in all our endeavors, both academic
                    and extracurricular.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-752">
                  <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-753">
                    <span className="text-2xl" data-id="element-754">🤝</span>
                  </div>
                  <h4 className="font-bold text-blue-900 mb-2" data-id="element-755">Integrity</h4>
                  <p className="text-gray-700 text-sm" data-id="element-756">
                    We uphold the highest standards of honesty, morality, and
                    ethical behavior.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-757">
                  <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-758">
                    <span className="text-2xl" data-id="element-759">💡</span>
                  </div>
                  <h4 className="font-bold text-blue-900 mb-2" data-id="element-760">Innovation</h4>
                  <p className="text-gray-700 text-sm" data-id="element-761">
                    We embrace innovative teaching methods and modern
                    technologies to enhance learning.
                  </p>
                </div>
              </div>
            </div>
          </section>}
        {/* School Anthem Section */}
        {activeTab === 'anthem' && <section className="mb-16" id="anthem" data-id="element-762">
            <div className="text-center mb-10" data-id="element-763">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-764">
                School Anthem
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-765"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-766">
                Our anthem that unites us in pride and purpose
              </p>
            </div>
            <div className="max-w-4xl mx-auto" data-id="element-767">
              <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white p-10 rounded-lg shadow-xl" data-id="element-768">
                <div className="space-y-8" data-id="element-769">
                  {/* Verse 1 */}
                  <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border-l-4 border-yellow-500" data-id="element-770">
                    <h4 className="text-yellow-300 font-bold mb-4 text-lg" data-id="element-771">
                      Verse 1
                    </h4>
                    <div className="space-y-2 text-lg" data-id="element-772">
                      <p data-id="element-773">Isonyin Grammar School</p>
                      <p data-id="element-774">God is our Foundation</p>
                      <p data-id="element-775">God helped our fathers to build thee</p>
                      <p data-id="element-776">Thou stand'st on a strong foundation</p>
                    </div>
                  </div>
                  {/* Chorus */}
                  <div className="bg-yellow-500 text-blue-900 p-6 rounded-lg shadow-lg" data-id="element-777">
                    <h4 className="font-bold mb-4 text-lg" data-id="element-778">Chorus</h4>
                    <div className="space-y-2 text-lg" data-id="element-779">
                      <p data-id="element-780">Thou stand'st our pride well won</p>
                      <p data-id="element-781">Whereever we may be</p>
                      <p data-id="element-782">Thou give'st knowledge to everyone</p>
                      <p className="font-bold" data-id="element-783">We will not forget thee</p>
                    </div>
                  </div>
                  {/* Verse 2 */}
                  <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border-l-4 border-yellow-500" data-id="element-784">
                    <h4 className="text-yellow-300 font-bold mb-4 text-lg" data-id="element-785">
                      Verse 2
                    </h4>
                    <div className="space-y-2 text-lg" data-id="element-786">
                      <p data-id="element-787">Get set for life's battle</p>
                      <p data-id="element-788">Rough way before you lie</p>
                      <p data-id="element-789">Roll up your sleeves prove your mettle</p>
                      <p data-id="element-790">Above the crowd will you please rise</p>
                      <p data-id="element-791">Don't aim at the little</p>
                    </div>
                  </div>
                  {/* Repeat Chorus */}
                  <div className="text-center italic text-yellow-300" data-id="element-792">
                    <p className="text-lg" data-id="element-793">(Chorus)</p>
                  </div>
                  {/* Verse 3 */}
                  <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border-l-4 border-yellow-500" data-id="element-794">
                    <h4 className="text-yellow-300 font-bold mb-4 text-lg" data-id="element-795">
                      Verse 3
                    </h4>
                    <div className="space-y-2 text-lg" data-id="element-796">
                      <p data-id="element-797">God bless teachers and taught</p>
                      <p data-id="element-798">Connected with this school</p>
                      <p data-id="element-799">Help them always whateveer their lots</p>
                      <p data-id="element-800">To keep their heads both calm and cool</p>
                      <p data-id="element-801">Acting well as they ought</p>
                    </div>
                  </div>
                  {/* Final Chorus */}
                  <div className="text-center italic text-yellow-300" data-id="element-802">
                    <p className="text-lg" data-id="element-803">(Chorus)</p>
                  </div>
                  {/* Composer */}
                  <div className="mt-8 text-center border-t border-white/30 pt-6" data-id="element-804">
                    <p className="text-yellow-300 font-semibold mb-1" data-id="element-805">
                      Composed by:
                    </p>
                    <p className="text-xl" data-id="element-806">Revd. S.T. Sheyin</p>
                    <p className="text-sm text-gray-300" data-id="element-807">Principal 1973</p>
                  </div>
                </div>
              </div>
            </div>
          </section>}
        {/* Badge & Motto Section */}
        {activeTab === 'badge' && <section className="mb-16" id="badge" data-id="element-808">
            <div className="text-center mb-10" data-id="element-809">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-810">
                School Badge & Motto
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-811"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-812">
                Symbols of our identity and guiding principle
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto" data-id="element-813">
              {/* School Badge */}
              <div className="text-center" data-id="element-814">
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-8 rounded-2xl shadow-xl mb-6 inline-block" data-id="element-815">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sVQyanUwhMphyB8je7Yk6r/4.png" alt="Isonyin Grammar School Badge" className="w-80 h-80 object-contain mx-auto" data-id="element-816" />
                </div>
                <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-817">
                  School Badge
                </h3>
                <p className="text-gray-700 text-lg leading-relaxed max-w-md mx-auto" data-id="element-818">
                  Our badge represents the pride and excellence of Isonyin
                  Grammar School
                </p>

                {/* Badge Symbolism */}
                <div className="mt-8 bg-blue-50 p-6 rounded-lg text-left max-w-md mx-auto" data-id="element-819">
                  <h4 className="font-bold text-blue-900 mb-4 text-center" data-id="element-820">
                    Badge Symbolism
                  </h4>
                  <ul className="space-y-3 text-sm text-gray-700" data-id="element-821">
                    <li className="flex items-start" data-id="element-822">
                      <span className="text-blue-700 mr-2" data-id="element-823">📖</span>
                      <span data-id="element-824">
                        <strong data-id="element-825">Open Book:</strong> Represents knowledge,
                        learning, and academic pursuit
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-826">
                      <span className="text-blue-600 mr-2" data-id="element-827">🔥</span>
                      <span data-id="element-828">
                        <strong data-id="element-829">Torch of Knowledge:</strong> Symbolizes
                        enlightenment and the light of education
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-830">
                      <span className="text-blue-700 mr-2" data-id="element-831">🛡️</span>
                      <span data-id="element-832">
                        <strong data-id="element-833">Shield Shape:</strong> Represents protection,
                        strength, and honor
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-834">
                      <span className="text-blue-700 mr-2" data-id="element-835">📅</span>
                      <span data-id="element-836">
                        <strong data-id="element-837">1956:</strong> Our founding year, marking our
                        rich heritage
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* School Motto */}
              <div data-id="element-838">
                <div className="bg-gradient-to-br from-blue-600 to-blue-700 p-10 rounded-2xl shadow-2xl" data-id="element-839">
                  <div className="text-center" data-id="element-840">
                    <h3 className="text-3xl font-bold text-white mb-6" data-id="element-841">
                      Our Motto
                    </h3>
                    <div className="bg-white text-blue-900 p-8 rounded-xl shadow-lg" data-id="element-842">
                      <p className="text-4xl font-bold mb-2" data-id="element-843">
                        "God is our Foundation"
                      </p>
                      <p className="text-blue-600 text-sm font-medium mt-4" data-id="element-844">
                        Est. 1956
                      </p>
                    </div>
                    <div className="mt-8 bg-white/20 backdrop-blur-sm p-6 rounded-xl" data-id="element-845">
                      <p className="text-white text-lg leading-relaxed" data-id="element-846">
                        This motto reflects our unwavering belief that divine
                        guidance and support form the bedrock of our
                        institution's success and the foundation upon which we
                        build character, knowledge, and excellence in our
                        students.
                      </p>
                    </div>
                  </div>
                </div>

                {/* School Colors */}
                <div className="mt-8 bg-white p-6 rounded-lg shadow-md" data-id="element-847">
                  <h4 className="font-bold text-blue-900 mb-4 text-center" data-id="element-848">
                    School Colors
                  </h4>
                  <div className="grid grid-cols-3 gap-4" data-id="element-849">
                    <div className="text-center" data-id="element-850">
                      <div className="w-full h-20 bg-blue-700 rounded-lg shadow-md mb-2" data-id="element-851"></div>
                      <p className="text-sm font-medium text-gray-700" data-id="element-852">
                        Royal Blue
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-853">Excellence</p>
                    </div>
                    <div className="text-center" data-id="element-854">
                      <div className="w-full h-20 bg-blue-900 rounded-lg shadow-md mb-2" data-id="element-855"></div>
                      <p className="text-sm font-medium text-gray-700" data-id="element-856">
                        Navy Blue
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-857">Strength</p>
                    </div>
                    <div className="text-center" data-id="element-858">
                      <div className="w-full h-20 bg-white border-2 border-gray-300 rounded-lg shadow-md mb-2" data-id="element-859"></div>
                      <p className="text-sm font-medium text-gray-700" data-id="element-860">White</p>
                      <p className="text-xs text-gray-500" data-id="element-861">Purity</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>}
        {/* Leadership Team Section */}
        {activeTab === 'leadership' && <section className="mb-16" id="leadership" data-id="element-862">
            <div className="text-center mb-10" data-id="element-863">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-864">
                Leadership Team
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-865"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-866">
                Meet the dedicated professionals who lead Isonyin Grammar
                School.
              </p>
            </div>
            {/* Senior School Leadership */}
            <div className="mb-12" data-id="element-867">
              <h3 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-868">
                Senior School Leadership
              </h3>
              <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mb-8" data-id="element-869">
                <div className="flex flex-col md:flex-row items-center" data-id="element-870">
                  <div className="md:w-1/4 mb-6 md:mb-0" data-id="element-871">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1qDmtoMp7nL55BBaiUBMby/WhatsApp_Image_2025-11-07_at_10.09.21.jpg" alt="Principal - Lamidi Yakubu Olorunyomi" className="w-48 h-48 object-cover rounded-full mx-auto border-4 border-white shadow-lg" data-id="element-872" />
                  </div>
                  <div className="md:w-3/4 md:pl-8" data-id="element-873">
                    <h3 className="text-2xl font-bold text-blue-900 mb-2" data-id="element-874">
                      Lamidi Yakubu Olorunyomi
                    </h3>
                    <p className="text-blue-700 font-medium mb-4" data-id="element-875">
                      Principal, Isonyin Grammar School (Senior)
                    </p>
                    <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-876">
                      As the Principal of Isonyin Grammar School, Mr. Lamidi
                      Yakubu Olorunyomi brings years of educational leadership
                      experience and a passion for academic excellence. Under
                      his guidance, the school continues to uphold its tradition
                      of quality education while embracing modern teaching
                      methodologies and technologies.
                    </p>
                    <p className="text-gray-700 leading-relaxed" data-id="element-877">
                      Mr. Lamidi is committed to fostering an environment where
                      students can develop academically, morally, and socially.
                      His leadership has been instrumental in the school's
                      continued success and recognition as a flagship
                      institution in Ogun State.
                    </p>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-878">
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow" data-id="element-879">
                  <div className="text-center mb-4" data-id="element-880">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2b5rD74o4Hgo2aWibDpBk6/WhatsApp_Image_2025-11-07_at_10.14.49.jpg" alt="Vice Principal (Senior School)" className="w-full h-64 object-cover rounded-lg mx-auto border-4 border-white shadow mb-4" data-id="element-881" />
                  </div>
                  <h3 className="text-xl font-bold text-blue-900 mb-1 text-center" data-id="element-882">
                    Vice Principal
                  </h3>
                  <p className="text-blue-700 text-sm font-medium mb-3 text-center" data-id="element-883">
                    Vice Principal, Senior School
                  </p>
                  <p className="text-gray-700 text-sm" data-id="element-884">
                    The Vice Principal of the Senior School oversees academic
                    programs, curriculum development, and ensures that our
                    educational offerings meet the highest standards and prepare
                    students for future success.
                  </p>
                </div>
              </div>
            </div>
            {/* Junior School Leadership */}
            <div className="mb-12" data-id="element-885">
              <h3 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-886">
                Junior School Leadership
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-887">
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow" data-id="element-888">
                  <div className="text-center mb-4" data-id="element-889">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4At7c5CE3BzAp6sTchxAjD/WhatsApp_Image_2025-11-07_at_10.15.32.jpg" alt="Principal (Junior School)" className="w-full h-64 object-cover rounded-lg mx-auto border-4 border-white shadow mb-4" data-id="element-890" />
                  </div>
                  <h3 className="text-xl font-bold text-blue-900 mb-1 text-center" data-id="element-891">
                    Principal
                  </h3>
                  <p className="text-blue-700 text-sm font-medium mb-3 text-center" data-id="element-892">
                    Principal, Junior School
                  </p>
                  <p className="text-gray-700 text-sm" data-id="element-893">
                    The Principal of the Junior School leads our foundational
                    education program, ensuring that young students receive the
                    best possible start to their academic journey with a strong
                    emphasis on character development and basic skills.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow" data-id="element-894">
                  <div className="text-center mb-4" data-id="element-895">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2JsCMQAe6VkMkEA5ahiNJu/WhatsApp_Image_2025-11-07_at_10.17.04.jpg" alt="Vice Principal (Junior School)" className="w-full h-64 object-cover rounded-lg mx-auto border-4 border-white shadow mb-4" data-id="element-896" />
                  </div>
                  <h3 className="text-xl font-bold text-blue-900 mb-1 text-center" data-id="element-897">
                    Vice Principal
                  </h3>
                  <p className="text-blue-700 text-sm font-medium mb-3 text-center" data-id="element-898">
                    Vice Principal, Junior School
                  </p>
                  <p className="text-gray-700 text-sm" data-id="element-899">
                    The Vice Principal of the Junior School supports the
                    Principal in managing daily operations, staff coordination,
                    and maintaining the high standards of education that our
                    younger students deserve.
                  </p>
                </div>
              </div>
            </div>
            {/* Junior School Staff */}
            <div className="mb-12" data-id="element-900">
              <h3 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-901">
                Our Dedicated Junior School Staff
              </h3>
              <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-902">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kCtjXZxCNmomG25TYhbjrQ/WhatsApp_Image_2025-11-07_at_10.21.13.jpg" alt="Junior School Staff" className="w-full h-96 object-cover" data-id="element-903" />
                <div className="p-6" data-id="element-904">
                  <p className="text-gray-700 leading-relaxed" data-id="element-905">
                    Our Junior School staff comprises dedicated and experienced
                    educators who are passionate about nurturing young minds.
                    They work collaboratively to create a supportive learning
                    environment where every child can thrive academically,
                    socially, and emotionally.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-blue-900 text-white p-8 rounded-lg" data-id="element-906">
              <h3 className="text-xl font-bold mb-6 text-center" data-id="element-907">
                Our Supportive Leadership Structure
              </h3>
              <p className="mb-4" data-id="element-908">
                The success of Isonyin Grammar School is built on a
                collaborative leadership approach that involves various
                stakeholders committed to our educational mission:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-909">
                <div data-id="element-910">
                  <h4 className="font-bold text-yellow-300 mb-2" data-id="element-911">
                    School Management
                  </h4>
                  <ul className="space-y-2 text-gray-200" data-id="element-912">
                    <li data-id="element-913">• Senior School Principal and Vice Principal</li>
                    <li data-id="element-914">• Junior School Principal and Vice Principal</li>
                    <li data-id="element-915">• Heads of Departments</li>
                    <li data-id="element-916">• Senior Teaching Staff</li>
                    <li data-id="element-917">• Administrative Officers</li>
                  </ul>
                </div>
                <div data-id="element-918">
                  <h4 className="font-bold text-yellow-300 mb-2" data-id="element-919">
                    External Support
                  </h4>
                  <ul className="space-y-2 text-gray-200" data-id="element-920">
                    <li data-id="element-921">• HRM Oba Abdul-Rasheed Cossy Salami (Kabiyesi)</li>
                    <li data-id="element-922">• Forum of Isonyin Professors</li>
                    <li data-id="element-923">• Old Students Association</li>
                    <li data-id="element-924">• Parent-Teacher Association</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>}
        {/* CTA Section */}
        <section className="bg-gradient-to-r from-blue-900 to-blue-800 text-white rounded-lg overflow-hidden" data-id="element-925">
          <div className="container mx-auto px-4 py-12" data-id="element-926">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-927">
              <div data-id="element-928">
                <h2 className="text-3xl font-bold mb-4" data-id="element-929">Visit Our Campus</h2>
                <p className="mb-6 leading-relaxed" data-id="element-930">
                  Experience Isonyin Grammar School firsthand. Schedule a visit
                  to tour our facilities, meet our staff, and learn more about
                  our programs and community.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-931">
                  <Button href="/contact" variant="primary" size="lg" data-id="element-932">
                    Contact Us
                  </Button>
                  <Button href="/virtual-tour" variant="outline" size="lg" className="border-white text-white hover:bg-white/10" data-id="element-933">
                    Virtual Tour
                  </Button>
                </div>
              </div>
              <div className="relative" data-id="element-934">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6tj9aedfkTMMHTP3tc3Muy/WhatsApp_Image_2025-08-07_at_14.26.51.jpg" alt="School campus" className="rounded-lg shadow-lg" data-id="element-935" />
                <div className="absolute -bottom-4 -right-4 bg-yellow-500 text-blue-900 font-bold py-2 px-4 rounded-lg transform rotate-3 shadow-lg" data-id="element-936">
                  Since 1956
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default About;